/**
 * Возвращает типизированный массив собственных перечисляемых свойств
 * указанного объекта в формате `[key, value]`
 *
 * @param entries Объект, чьи перечислимые свойства будут возвращены в виде массива `[key, value]`.
 * @returns Массив перечислений собственных свойств объекта с парами `[key, value]`.
 */
export const toEntries = <K extends string, V>(entries: Record<K, V>) =>
  Object.entries(entries) as [K, V][];
